import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';

import usePaths from 'src/hooks/use-paths';
import CartItemClass from 'src/state/cart-item';
import ProductImage from 'src/components/product-image';

export const MatchingItem = ({ item }: { item: CartItemClass }): JSX.Element => {
  const { product } = item;
  const { href } = usePaths({ product });

  return (
    <Link href={href}>
      <Anchor href={href}>
        <ProductImage product={product} width={48} height={48} alt={product.name} />
      </Anchor>
    </Link>
  );
};

const Anchor = styled.a`
  display: block;

  img {
    display: block;
  }
`;
